import { render, staticRenderFns } from "./ConfirmUpdatingModal.vue?vue&type=template&id=70246475&"
import script from "./ConfirmUpdatingModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmUpdatingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports